import React from 'react';
import {TypeForm} from "../types";
import {CategoryList} from "./CategoryList";
import FormCategory from "./FormCategory";
import Modal from "./Modal";
import {useModal} from "../Contexts/Modal";

const Sidebar: React.FC = () => {

    const {openModal, closeModal} = useModal()

    return (
        <>
            <div style={{width: '200px', backgroundColor: '#f4f4f4', padding: '20px'}}>
                <h3 className={"flex-row center"}>Catégories
                    <button className={"addCategory circular"} onClick={() => openModal(<FormCategory typeForm={TypeForm.create}/>)}>+</button>
                </h3>
                <CategoryList/>
            </div>
        </>
    );
};

export default Sidebar;
